import React from "react";
import SubsectionHeader from "@/components/shared/SubsectionHeader";
import Footer from "@/components/Footer";
import FeedbackForm from "./FeedbackForm";
import { useUserStore } from "@/stores/userStore";

const ContactPage: React.FC = () => {
  const { currentUser } = useUserStore();

  return (
    <div className="min-h-screen bg-background">
      <div className="px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <SubsectionHeader
          title="意见反馈"
          description="请将问题详细告诉我们，我们将尽快跟进"
          icon="MessageSquare"
          variant="hero"
        />

        <div className="mx-auto max-w-2xl py-6 sm:py-8">
          <FeedbackForm email={currentUser?.email} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
